import { Component, output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconRegistry, MatIcon } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-delete-button',
  standalone: true,
  imports: [CommonModule, MatIcon],
  templateUrl: './delete-button.html',
})
export class DeleteButtonComponent {
  constructor(
    private readonly iconRegistry: MatIconRegistry,
    private readonly sanitizer: DomSanitizer,
  ) {
    this.iconRegistry.addSvgIcon(
      'delete-icon',
      this.sanitizer.bypassSecurityTrustResourceUrl('icons/delete_icon.svg'),
    );
  }

  delete = output<void>();

  onDelete(): void {
    this.delete.emit();
  }
}
